import React from 'react';
import { motion } from 'framer-motion';
import { highlightTerms } from '../highlightTerms';
import { X } from 'lucide-react';

export const MistakesSlide = ({ slide }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div
      className="h-full w-full flex flex-col justify-center items-center px-8 md:px-12 lg:px-20 py-12"
      data-testid={`slide-${slide.id}`}
    >
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="max-w-4xl w-full"
      >
        <motion.h2
          variants={itemVariants}
          className="pres-font-heading text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white mb-16 text-center"
        >
          {highlightTerms(slide.title)}
        </motion.h2>

        <div className="space-y-6">
          {slide.mistakes?.map((mistake, idx) => (
            <motion.div
              key={idx}
              variants={itemVariants}
              className="group"
            >
              <div className="flex items-center gap-6 bg-[#D31113]/10 border border-[#D31113]/30 rounded-xl p-6 hover:bg-[#D31113]/20 transition-colors">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#D31113] flex items-center justify-center">
                  <X className="w-6 h-6 text-white" strokeWidth={3} />
                </div>
                <p className="font-sans text-xl md:text-2xl text-white font-medium">
                  {highlightTerms(mistake)}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};
